import styled from 'styled-components';

export const SocialLinksListContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  column-gap: 1.5rem;

  .social-media-icon-link {
    position: relative;

    .sr-only {
      position: absolute;
      width: 1px;
      height: 1px;
      padding: 0;
      overflow: hidden;
      clip: rect(0, 0, 0, 0);
      white-space: nowrap;
      clip-path: inset(50%);
      border: 0;
    }
  }
`;
